import ActionTile from "./ActionTile";

export default ActionTile;
